import { gravComponentSchema } from '../deep-form-grav';
import { AccountToAccountProps, defaults, TransferRule } from '../../../../components/ui/AccountToAccount';

 
const { s, l, bl, c, v, src, h, toExport } = gravComponentSchema<AccountToAccountProps>({
  title: 'Account To Account',
  link: 'https://www.notion.so/mlmsoft/AccountToAccount-c8e1dd6dd13b4ebd9b7480be5882ea0b',
  text: text(),
},
  defaults,
);

export default toExport;

s.add('walletId').as(l.clone('walletId'))
  .title('Default wallet').mandatory()
  .col(6);

s.add('confirmBy').input('dictionary').data([
  { title: 'Email', value: 'email' },
  { title: 'Phone', value: 'phone' },
])
  .props({ clearable: true })
  .title('Requires confirmation by').mandatory(false).col(6);

// Transfer Rules Schema
const transferRuleSchema = s.spawn<TransferRule>().input('dform').data([
  s.spawn<number>('accountId').input('text')
    .props({ class: 'mr-md-2', density: 'compact', dfTitleInside: true, hideDetails: false })
    .title('Account ID')
    .desc('Account ID for which this rule applies')
    .mandatory()
    .convert((v: any) => v === '' || v === null || v === undefined ? 0 : Number(v))
    .col(3)
    .item(),
  
  s.spawn<'allow' | 'deny'>('mode').input('dictionary')
    .data([
      { title: 'Allow only', value: 'allow' },
      { title: 'Deny', value: 'deny' },
    ])
    .props({ class: 'mr-md-2', density: 'compact', dfTitleInside: true, hideDetails: false })
    .title('Mode')
    .desc('allow: only listed accounts allowed, deny: listed accounts blocked')
    .mandatory()
    .col(3)
    .item(),
  
  s.spawn<string>('relatedAccounts').input('text')
    .props({ density: 'compact', dfTitleInside: true, hideDetails: false })
    .title('Related Account IDs')
    .desc('Comma-separated list (e.g., 10,12,15,18)')
    .mandatory()
    .col(6)
    .item(),
])
  .init(() => ({ accountId: 0, mode: 'deny', relatedAccounts: '' }))
  .props({ style: 'border: 1px solid #ccc; padding: 10px; margin: 5px; border-radius: 5px;' });

// Add transfer rules array with validation
s.add('transferRules').input('dlist').data(transferRuleSchema.item())
  .title('Transfer Restrictions')
  .desc('Define transfer rules for specific accounts. Each account can have only one rule.')
  .validators([
    (rules: TransferRule[] | undefined) => {
      if (!rules || rules.length === 0) return;
      
      const accountIds = rules.map(r => r.accountId);
      const uniqueIds = new Set(accountIds);
      
      if (accountIds.length !== uniqueIds.size) {
        return 'Each account ID can have only one rule. Duplicate account IDs found.';
      }
    }
  ])
  .col(12);

function text() {
  return `
<b>Account To Account</b>
This allows to transfer currency from one account to another.
`;
}
